import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css'
import '../scss/app.scss'
import Router from './Router'
import IdleTimer from 'react-idle-timer'
import Logout from '../components/account/log_in/Logout'

class App extends Component {

  constructor (props) {
    super(props)
    this.idleTimer = null
    this.state = {
      timeout: 3600000, //the time, in milliseconds, of inactivity before the user is logged out
      isIdle: false,
    }
    // Bind event handlers and methods
    this.onActive = this._onActive.bind(this)
    this.onIdle = this._onIdle.bind(this)

  }

  _onActive () {
    this.setState({ isIdle: false })
  }

  _onIdle () {
    this.setState({ isIdle: true})
  }

  componentDidMount () {
  }

  render () {
    return (
      <div>
        {this.state.isIdle && localStorage.getItem('pos-session') ? <Logout />  : null}
        <div>
          <IdleTimer
            ref={ref => { this.idleTimer = ref }}
            onActive={this.onActive}
            onIdle={this.onIdle}
            timeout={this.state.timeout}
            startOnMount 
          />
          <Router />
        </div>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/app/App.js